import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Search, Button, Loading } from 'carbon-components-react';

import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';

import TileHeader from '../../components/TileHeader/TileHeader';
import ConfirmModal from '../../components/Modal/ConfirmModal';
import ConditionsGrid from './ConditionsGrid';
import ConditionDetailModal from './ConditionDetailModal';

import { getAllConditions, deleteCondition } from '../../api/conditions';

import { toaster } from '../../helpers/toaster';

const Conditions = () => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(false);

  const [conditionList, setConditionList] = useState([]);
  const [search, setSearch] = useState("");
  const [searchGrid, setSearchGrid] = useState("");
  const [openConditionModal, setConditionModalStatus] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [refreshData, setRefreshData] = useState(false);
  const [sort, setSort] = useState("")

  // modal params
  const [modalConditionName, setModalConditionName] = useState("");
  const [modalSynonyms, setModalSynonyms] = useState([]);
  const [modalRootCondition, setModalRootCondition] = useState([]);
  const [modalStudies, setModalStudies] = useState([]);
  const [detailModalMode, setDetailModalMode] = useState("");
  const [conditionId, setConditionId] = useState(null);
  const [description, setDescription] = useState("")
  const [imageData, setImageData] = useState({})
  const [additionalInfo, setAdditionalInfo] = useState({})

  const onlyAttachment = localStorage.getItem('only_attachment')
  const addConditionBtnStyle = {
    padding: "5px 10px",
    height: "30px",
    minHeight: "30px"
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchGrid(search);
    }, 1000)
    // if this effect run again, because `value` changed, we remove the previous timeout
    return () => clearTimeout(timeout)
  }, [search]);
  // useEffect(() => {
  //   getConditions();
  // }, []);

  // const getConditions = () => {
  //   setLoading(true);
  //   getAllConditions().then(items => {
  //     items = items.map(item => ({
  //       ...item,
  //       synonymsText: (item.synonyms || []).slice(0, 5).join(", "),
  //       studiesText: (item.studies || []).map(ele => ele.org_study_id).slice(0, 2).join(", "),
  //     }));
  //     setConditionList(items);
  //     setLoading(false);
  //   });
  // };

  const addNewCondition = () => {
    setDetailModalMode("create");
    setModalConditionName("");
    setModalSynonyms([]);
    setModalStudies([]);
    setModalRootCondition([]);

    setConditionModalStatus(true);
  };

  const conditionRowClicked = (data) => {
    setDetailModalMode("update");
    setConditionId(data.id);
    setModalConditionName(data.name || "");
    setDescription(data?.additional_info?.description)
    setImageData(data?.image_info)
    setAdditionalInfo(data?.additional_info)

    let synIds = [];
    let syns = [];
    if (data.synonyms && data.synonyms.length) {
      syns = data.synonyms.map(syn=> ({label: syn, value: syn}))
    }
    setModalSynonyms(syns);
    console.log('modal syns ', syns);

    let studyIds = [];
    if (data.studies && data.studies.length) {
      studyIds = data.studies.map(study => study.id);
    }
    setModalStudies(studyIds);

    let rootCond = [];
    if (data.root_condition && Object.keys(data.root_condition).length) {
      rootCond = data.root_condition?.id
    }
    setModalRootCondition(rootCond);

    setConditionModalStatus(true);
  };

  const showDeleteConfirm = (itemId) => {
    setOpenDeleteModal(true);
    setDeleteItemId(itemId);
  };

  const confirmDelete = () => {
    setOpenDeleteModal(false);
    setLoading(true);
    deleteCondition(deleteItemId).then(res => {
      toaster("Condition deleted successfully", "success")
      setLoading(false);
      setRefreshData(true);
      // getConditions();
    });
  };
  const refreshTriggered = () => {
    setRefreshData(true);
    console.log("reached refresh triggered");
  }

  return (
    <Container>
      <ContentContainer>

        <TileHeader
            title="Conditions"
            // subtitle="A list of all conditions. To add a condition click the ‘Add Condition’ button. Edit condition values directly in the table."
            size="lg"


        />
        {
					loading ?
					<Loading

          />
					:
					<></>
				}

        <ConditionsContent>
          <ActionBar>
            <div style={{ width: "300px" }}>
              <Search
                size="sm"
                value={search}
                labelText="search"
                onChange={e => setSearch(e.target.value)}
                placeHolderText="Search using any data value"/>
            </div>

            <Button
              kind="primary"
              onClick={() => addNewCondition()}
              style={addConditionBtnStyle}
              disabled={onlyAttachment === "true"}
            >Add Condition</Button>
          </ActionBar>

          <ConditionsGrid
            conditionList={conditionList}
            search={searchGrid}
            onRowClicked={conditionRowClicked}
            onDeleteClicked={showDeleteConfirm}
            setRefresh={setRefreshData}
            refresh={refreshData}
            sort={sort}
            setSort={setSort}
          />
        </ConditionsContent>

        <ConditionDetailModal
          mode={detailModalMode}
          conditionId={conditionId}
          open={openConditionModal}
          name={modalConditionName}
          synonyms={modalSynonyms}
          parentCondition={modalRootCondition}
          studies={modalStudies}
          refreshConditions={refreshTriggered}
          onClose={() => setConditionModalStatus(false)}
          refreshData={refreshData}
          description={description}
          imageData={imageData}
          additionalInfo={additionalInfo}
        />

        <ConfirmModal
          title="Confirmation"
          content="Are you sure to delete condition?"
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          onConfirm={() => confirmDelete()}
        />

      </ContentContainer>
    </Container>
  );
};

export default Conditions;

const ConditionsContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 2em;
  background-color: #fff;
`

const ActionBar = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const ConditionsFooter = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  padding: 0px 20px 20px 20px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
`
